<template>
  <div class="container-fluid ps-md-0">
    <div class="row g-0">
      <div class="d-none d-md-flex col-md-4 col-lg-6 bg-image"></div>
      <div class="col-md-8 col-lg-6">
        <div class="login d-flex align-items-center py-5">
          <div class="container">
            <div class="row">
              <div class="col-md-9 col-lg-8 mx-auto">
                <h3 class="login-heading mb-4 text-center">Китоби Ҷамоат</h3>

                <!-- Sign In Form -->
                <form @submit.prevent="sign">
                  <div class="form-floating mb-3">
                    <label for="floatingInput">Номи истифодабаранда</label>
                    <input type="text" class="form-control" id="floatingInput" placeholder="" v-model="login">

                  </div>
                  <div class="form-floating mb-3">
                    <label for="floatingPassword">Рамз</label>
                    <input type="password" class="form-control" id="floatingPassword" placeholder="" v-model="pass">

                  </div>
                  <div class="form-floating mb-3">
                    <span class="text-danger">{{ error }}</span>


                  </div>


                  <div class=" text-right">
                    <button class="btn btn-lg btn-primary btn-login text-uppercase fw-bold mb-2"
                      type="submit">Даромад</button>
                    <div class="text-center text-muted">
                      Версияи {{ this.$store.state.version }}
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      login: '',
      pass: '',
      user: '',
      error: '',
      token: { code: 0 }
    }
  },
  methods: {
    async sign() {
      console.log('logging')



      if (this.login == '' || this.pass == '') {
        this.error = "Номи истифодабаранда ё рамзи махфӣ холӣ буда наметавонад";

      }


      if (!this.$store.state.logins.includes(this.login.toLowerCase())) {
        await this.getCert();

        await this.getUserToken();

        if (this.token.code == 0) {
          this.error = "Токенро пайваст намоед";
          return;
        }
      }
      else {
        await this.getUser();
      }


      if (this.user.Terid > 0) {
        this.$store.state.terid = this.user.Terid;
        this.$store.state.tername = this.user.Tername;
        this.$store.state.fio = this.user.FIO;
        this.$store.state.iduser = this.user.ID;

        this.$store.state.atoken = this.user.AToken;
        this.$store.state.rtoken = this.user.RToken;
        console.log('this.$store.state.atoken', this.$store.state.atoken)
        console.log('this.$store.state.rtoken', this.$store.state.rtoken)
        console.log('logged', this.user)
        this.$router.push('/')
        this.$store.state.login = true;




      }
      else {
        this.error = 'Чунин истифодабаранда мавҷуд нест'

        if (this.user.ID == -9) {
          this.error = this.user.Tername;
        }


        console.log('no logged', this.user)
      }


    },

    async getUserToken() {
      // console.log('token',this.token)
      if (this.token.code == 0) {
        this.error = "Токенро пайваст намоед";
        return;
      }
      // console.log('token 2',this.token)

      var auth = {
        login: this.login,
        pass: this.pass,
        tsn: this.token.tokenID,
        csn: this.token.serial,
        ver: this.$store.state.version

      }

      console.log('auth', auth)

      await fetch(this.$store.state.server + "/api/login/", {
        method: "post",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },

        body: JSON.stringify(auth)
      })
        .then(res => res.json())
        .then(data => { this.user = data, console.error("There was an error!", data) })
        .catch(error => {
          console.log("There was an error!", error)
        });



    },


    async getUser() {

      await fetch(this.$store.state.server + "/api/login/" + this.login + "/" + this.pass + " /")
        .then(res => res.json())
        .then(data => this.user = data)
        .catch(error => {
          console.error("There was an error!", error)
        });



    },

    async getCert() {

      this.token = { code: 0 };

      const data = { device: 'etoken', src: '123123', password: 12345678 };
      {
        await fetch('http://localhost:5000/sign', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        }).then(res => res.json())
          .then(data => { this.token = data, console.error("There was an error!", data) })
          .catch(error => {
            console.log("There was an error!", error)
          });

        // Проверка ответа сервера
        // if (!response.ok) 
        // {
        //   //throw new Error(`HTTP error! status: ${response.status}`);

        //   console.log('response.status',response.status)
        //   return;

        // }

        // const result = await response.json();
        // console.log('result', result); // Исправлено на console.log
        // this.token=result;

        // Красивая и понятная визуализация ответа сервера
        // const message = result.code;
        // const serial = result.serial;
        // const tokenID = result.tokenID;
        // const sign = result.sign;

        // console.log('this.token',this.token);


      }


    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  min-height: 100vh;
}

.bg-image {
  background-image: url('/logo.jpg');
  background-size: cover;
  background-position: center;
  filter: blur(2px);
  -webkit-filter: blur(2px);
}

.login-heading {
  font-weight: 300;
}

.btn-login {
  font-size: 0.9rem;
  letter-spacing: 0.05rem;
  padding: 0.75rem 1rem;
}
</style>